import { useMasterHoldMaintenanceTracked } from "presentation/store/MasterHold/MasterHoldMaintenanceProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import MasterHoldEditPanel from "./MasterHoldEditPanel";
import MasterHoldMaintenance from "./MasterHoldMaintenance";

export const MasterHoldMasterView: React.FC = () => {
    const [masterHoldState] = useMasterHoldMaintenanceTracked();
    const { isAdd, isEditable } = masterHoldState.masterState;

    return <>
        <div className="main-comp-wrapper im-hide-side-form-draggable" >
            <MasterHoldMaintenance />
            {
                ((isAdd || isEditable) &&
                    <SliderPanel
                        isOpen={true}
                        leftSectionWidth={"0%"}
                        rightSectionWidth={"100%"}
                        //leftChildren={<MasterHoldHeaderFormPanel />}
                        rightChildren={<MasterHoldEditPanel />}
                    />
                )
            }
        </div>
    </>
}